import { ValueOf } from '@redsift/design-system';

/** TOOLTIP */

export const TooltipVariant = {
  none: 'none',
  label: 'label',
  value: 'value',
  percent: 'percent',
  custom: 'custom',
};
export type TooltipVariant = ValueOf<typeof TooltipVariant>;

/** LEGEND */
export const LegendVariant = {
  none: 'none',
  label: 'label',
  value: 'value',
  percent: 'percent',
  custom: 'custom',
} as const;
export const LabelVariant = LegendVariant;
export type LegendVariant = ValueOf<typeof LegendVariant>;
export type LabelVariant = LegendVariant;
